import { api } from "@services";

export const postIntegration = form => {
  return api.post(`/v1/assistant-integrate`, form);
}